export default (value, options = {
    style: 'currency',
    currency: 'TWD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
}) => {
    return Intl.NumberFormat('zh-Hant', options)
        .format(value)
}
